/**
 * КОПИРОВАНИЕ В БУФЕР
 *
 * Современный способ — `navigator.clipboard` — отказывает чаще, чем
 * кажется: в приложении, открытом не по защищённому соединению,
 * в окне, которое браузер не считает «в фокусе», и просто потому, что
 * пользователь когда-то запретил доступ к буферу этому сайту.
 *
 * Отказ выглядит для человека как поломка: он нажал «Копировать»,
 * ничего не произошло, и вставлять ему нечего. Поэтому здесь есть
 * запасной путь — старый, через невидимое поле ввода. Он некрасив,
 * но работает там, где новый молчит.
 */
export async function copyText(text: string): Promise<boolean> {
  if (!text) return false

  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // Пробуем по-старому
  }

  try {
    const field = document.createElement('textarea')
    field.value = text
    // Поле должно быть на странице, иначе выделять нечего.
    // Прячем его так, чтобы страница не дёрнулась и не прокрутилась
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.top = '0'
    field.style.left = '0'
    field.style.opacity = '0'
    field.style.pointerEvents = 'none'

    document.body.appendChild(field)
    field.select()
    field.setSelectionRange(0, text.length)

    const done = document.execCommand('copy')
    document.body.removeChild(field)
    return done
  } catch {
    return false
  }
}
